import { render, staticRenderFns } from "./LapidusClasses.vue?vue&type=template&id=bcda1b44&"
import script from "./LapidusClasses.vue?vue&type=script&lang=js&"
export * from "./LapidusClasses.vue?vue&type=script&lang=js&"
import style0 from "./LapidusClasses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports